export default __webpack_public_path__ + "static/plume_main-e3c49f314905d3d5e564a887dc69795d.mp4";